import { render, staticRenderFns } from "./FileExtract.vue?vue&type=template&id=074d411c&scoped=true&"
import script from "./FileExtract.vue?vue&type=script&lang=ts&"
export * from "./FileExtract.vue?vue&type=script&lang=ts&"
import style0 from "./FileExtract.vue?vue&type=style&index=0&id=074d411c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d411c",
  null
  
)

export default component.exports